/* eslint camelcase: 0 */
import { stringify } from "query-string"

import jsonFetch from "common/services/fetch/jsonFetch"
import { transport } from "mmb/services/bookings/bookingsApi"
import apiBookingTokens from "mmb/services/apiBookingTokens/apiBookingTokens"
import sniffError from "common/services/utils/sniffError"
import { API_ACTIONS } from "mmb/consts/booking"
import type { BookingId } from "mmb/types/primitiveTypes"

export const apiUrl = () => window.reduxStore.getState().options.get("bookingApiUrl")

// Warning: Sending tokens in url is not good idea
export const authFetch = (bid, url, options) => {
  const token = apiBookingTokens.get(bid)
  const urlWithToken = `${url}?${stringify(token)}`

  return jsonFetch(urlWithToken, options).then(body => {
    const maybeError = sniffError(null, { body })
    if (maybeError) throw new Error(maybeError)
    return body
  })
}

export function requestFastRefund(bid: BookingId) {
  return authFetch(bid, `${apiUrl()}/mmb/latest/bookings/${bid}/refund`, {
    body: {
      based_on: "grace_period",
      amount: 0, // 0 means all
      gate: "zooz",
      immediate: true,
    },
  })
}

export function requestPendingRefund({ bid, payload }) {
  return authFetch(bid, `${apiUrl()}/api/v0.1/users/self/pending_refunds/${bid}`, {
    body: payload,
  })
}

export function changeInsurance({ bid, data, price, currency, useBalance }) {
  const payload = {
    insurances: data,
    payment: {
      paid_by_card: {
        gate: "zooz",
        price: {
          amount: useBalance ? "0" : price.toString(),
          currency: currency.toUpperCase(),
        },
      },
      paid_by_credits: {
        price: {
          amount: useBalance ? price.toString() : "0",
          currency: currency.toUpperCase(),
        },
      },
    },
  }
  return transport("POST", bid, `/mmb/v1/bookings/${bid}/insurances`, null, payload)
}

export function requestPendingService({ service, bid, booked_at }) {
  const body = {
    action: API_ACTIONS.CREATE,
    category: `service.${service.category}`,
    pending_additional_service_id: service.id,
    orig_price: service.payment.amount,
    currency: service.payment.currency,
    comment: service.description,
    payment: { gate: "zooz" },
    use_credits: false,
    booked_at,
  }
  return authFetch(bid, `${apiUrl()}/api/v0.1/users/self/bookings/${bid}`, {
    body,
  })
}

export function changeBags({ bid, bags, price, currency, useBalance = false, booked_at }) {
  const body = {
    action: API_ACTIONS.CREATE,
    orig_price: price,
    currency,
    bags,
    use_credits: useBalance,
    payment: { gate: useBalance ? "credits" : "zooz" },
    booked_at,
  }
  return authFetch(bid, `${apiUrl()}/api/v0.1/users/self/bookings/${bid}`, {
    body,
  })
}

export function changeBaggage({ bid, payload }) {
  return transport("POST", bid, `/mmb/v1/bookings/${bid}/baggage`, null, payload)
}
